/** FuryBot input filters — profanity detection, off-topic check */

// Returns true if text contains profanity/abuse
export const isProfane = (text) => {
  return /\bf+[u*@]+c?k|sh[i!1]+t|a[s$]+h[o0]+le|b[i!1]+tch|d[i!1]+ck|damn|crap|stfu|wtf|idiot|stupid|dumb|suck|hate you|you suck|go away|die\b/i.test(text);
};
